module.exports = __webpack_public_path__ + "static/media/standardWithoutLink.317e58f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headers/standardWithoutLink.png
// module id = 1243
// module chunks = 0